<div class="faq-container">
  <h1>Foire aux questions (FAQ)</h1>
  <p class="intro">Découvrez comment utiliser Niaga et profitez au mieux de l'application.</p>

  <section class="faq-section">
    <h2>Compte et connexion</h2>
    <details>
      <summary>Comment créer un compte ?</summary>
      <p>Depuis l'écran d'authentification, cliquez sur « Créer un compte », saisissez votre email et votre mot de passe, puis suivez les étapes de vérification. Vous pouvez aussi configurer votre profil juste après la création.</p>
    </details>
    <details>
      <summary>Je n’arrive pas à me connecter, que faire ?</summary>
      <p>Vérifiez votre email et votre mot de passe. Utilisez « Mot de passe oublié ? » pour réinitialiser. Si vous vous connectez via numéro virtuel, assurez‑vous d’entrer le bon numéro et le bon mot de passe associés.</p>
    </details>
    <details>
      <summary>Comment vérifier mon email ?</summary>
      <p>Un lien de vérification est envoyé après l’inscription. Si vous ne le trouvez pas, vérifiez le dossier spam ou relancez la vérification via la page « Vérification d’email ».</p>
    </details>
  </section>

  <section class="faq-section">
    <h2>Profil et paramètres</h2>
    <details>
      <summary>Comment modifier mon profil (nom, bio, photo) ?</summary>
      <p>Allez dans « Paramètres » puis « Informations personnelles ». Vous pouvez aussi utiliser l’option « Modifier le profil » pour changer le nom, la bio et la photo de profil. Le recadrage d’images est pris en charge.</p>
    </details>
    <details>
      <summary>Comment changer ma langue ?</summary>
      <p>Rendez‑vous dans « Paramètres » → « Langue » et choisissez la langue d’interface. Les contenus multimédias restent dans la langue de publication.</p>
    </details>
    <details>
      <summary>Où trouver la page À propos et la politique de confidentialité ?</summary>
      <p>La page « À propos » est accessible depuis le pied de page. Les informations sur la confidentialité sont disponibles dans « Paramètres » → « Confidentialité ».</p>
    </details>
  </section>

  <section class="faq-section">
    <h2>Fil d’actualité, posts et commentaires</h2>
    <details>
      <summary>Comment publier un post ?</summary>
      <p>Depuis le fil, appuyez sur « Créer un post ». Ajoutez du texte, des images ou des vidéos, puis publiez. Vous pouvez prévisualiser vos médias avant la mise en ligne.</p>
    </details>
    <details>
      <summary>Puis‑je modifier ou supprimer un post ?</summary>
      <p>Oui. Ouvrez le menu du post (⋯), puis choisissez « Modifier » ou « Supprimer ». La suppression est permanente. Les modifications mettent à jour le contenu instantanément.</p>
    </details>
    <details>
      <summary>Comment répondre ou éditer un commentaire ?</summary>
      <p>Utilisez « Répondre » sous un post pour commenter. Vous pouvez aussi éditer vos commentaires via le menu dédié. Les réponses sont affichées en fil de discussion.</p>
    </details>
    <details>
      <summary>Comment voir qui a aimé mon post ?</summary>
      <p>Appuyez sur le compteur de likes pour ouvrir la fenêtre des utilisateurs ayant aimé votre publication.</p>
    </details>
  </section>

  <section class="faq-section">
    <h2>Stories et lecteur</h2>
    <details>
      <summary>Comment créer ou voir une Story ?</summary>
      <p>Depuis le carrousel des Stories, cliquez sur « Créer une Story » pour ajouter une image/vidéo. Pour voir les Stories, appuyez sur une vignette ; le lecteur s’ouvre avec navigation par balayage.</p>
    </details>
    <details>
      <summary>Le lecteur vidéo ne se lance pas, que faire ?</summary>
      <p>Vérifiez votre connexion et réessayez. Le lecteur s’adapte à la bande passante et affiche une barre de progression de lecture.</p>
    </details>
  </section>

  <section class="faq-section">
    <h2>Messages et notifications</h2>
    <details>
      <summary>Comment envoyer un message ?</summary>
      <p>Ouvrez « Messages », sélectionnez un contact et écrivez. Les conversations récentes s’affichent avec un indicateur de non‑lu. La recherche permet de filtrer vos discussions.</p>
    </details>
    <details>
      <summary>Puis‑je rechercher des utilisateurs et des posts ?</summary>
      <p>Oui, utilisez la barre de recherche. Les résultats incluent utilisateurs, posts et hashtags pertinents.</p>
    </details>
    <details>
      <summary>Comment fonctionnent les notifications ?</summary>
      <p>Les notifications s’affichent dans l’onglet dédié pour les likes, commentaires, nouveaux abonnés et mentions.</p>
    </details>
  </section>

  <section class="faq-section">
    <h2>Sécurité et confidentialité</h2>
    <details>
      <summary>Comment protéger mon compte ?</summary>
      <p>Utilisez un mot de passe fort, ne le partagez pas et déconnectez‑vous des appareils publics. Vérifiez régulièrement votre email associé.</p>
    </details>
    <details>
      <summary>Comment supprimer mon compte ?</summary>
      <p>Vous pouvez effectuer une « Demande de suppression de compte » via le lien en pied de page. Un administrateur valide la demande conformément aux règles en vigueur.</p>
    </details>
  </section>

  <section class="faq-section">
    <h2>Assistance</h2>
    <details>
      <summary>J’ai encore besoin d’aide.</summary>
      <p>Contactez le support depuis la page « À propos » ou via l’adresse indiquée dans l’application. Décrivez votre problème et joignez des captures si possible.</p>
    </details>
  </section>

  <div class="back-links">
    <a routerLink="/about">En savoir plus sur Niaga</a>
    <a routerLink="/delete-account">Demande de suppression de compte</a>
  </div>
</div>

